import { useCallback } from "react";

import ACL_RELATIONSHIPS from "acl-relationships";
import usePageTitle from "hooks/usePageTitle";
import { getNextQueryParams } from "components/helpers";
import withRoleCheck from "components/hocs/withRoleCheck";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import _DialSessionModal from "routes/dial_sessions/components/DialSessionModal";
import DialSessionService from "services/DialSessions";
import {
  useDialSessionTable,
  invalidateDialSessionTableQuery,
} from "hooks/useDialSessionTable";

export const DIAL_SESSION_TABLE_CONSTANTS = {
  tableName: "dialSessions",
  queryKey: "dial-sessions",
  className: "DialSession",
  exportTableName: "DialSessionTable",
  header: "Dial Sessions",
  headerIcon: "call",
};

const NewDialSessionModal = withRoleCheck(_DialSessionModal, [
  ACL_RELATIONSHIPS.dialSession.create,
  ACL_RELATIONSHIPS.voicemailForFilters.read,
  ACL_RELATIONSHIPS.emailUrlForms.read,
  ACL_RELATIONSHIPS.campaigns.read,
  ACL_RELATIONSHIPS.tag.read,
  ACL_RELATIONSHIPS.user.read,
  ACL_RELATIONSHIPS.campaignStatuses.read,
]);
const defaultFilters = { status: true };

const DialSessionTableV3 = () => {
  usePageTitle(DIAL_SESSION_TABLE_CONSTANTS.header);

  const { filters, columns } = useDialSessionTable({
    tableName: DIAL_SESSION_TABLE_CONSTANTS.tableName,
  });

  const fetchDialSessions = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response = await DialSessionService.getSessions({
          ...nextQueryParams,
          summary: true,
        });

        return response;
      } catch (error) {
        console.error("Error fetching dial sessions:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      headerIcon={DIAL_SESSION_TABLE_CONSTANTS.headerIcon}
      header={DIAL_SESSION_TABLE_CONSTANTS.header}
      tableName={DIAL_SESSION_TABLE_CONSTANTS.tableName}
      queryKey={DIAL_SESSION_TABLE_CONSTANTS.queryKey}
      className={DIAL_SESSION_TABLE_CONSTANTS.className}
      exportTableName={DIAL_SESSION_TABLE_CONSTANTS.exportTableName}
      defaultFilters={defaultFilters}
      fetchData={fetchDialSessions}
      createButton={
        <NewDialSessionModal
          button
          onSuccess={invalidateDialSessionTableQuery}
        />
      }
      enableSearch
      enableSettings
      invalidateData={invalidateDialSessionTableQuery}
    />
  );
};

export default DialSessionTableV3;
